import { API_EVENTS_URL } from './utils/config';
import {
  setBatcher,
  setConfig,
  setFlesher,
  BaseEvent,
  Batch,
  getSender,
  getAll,
} from '@elevio-kb/eventer';
import {
  getUser,
  getCompanyUid,
  getLanguageId,
  getIsCypressMode,
} from './utils/globals';

export function fillEvent(): BaseEvent {
  const user = getUser();
  return {
    ...getAll(),
    app_lang: getLanguageId(),
    customer_uid: getCompanyUid(),
    user_uid: user.uid,
    user_email: user.email,
  };
}

export function setupAnalytics(): { batch: Batch } {
  const isCypressMode = getIsCypressMode();

  setConfig({ isDisabled: true });
  setFlesher(fillEvent);

  if (process.env.NODE_ENV !== 'test' && !isCypressMode) {
    if (!API_EVENTS_URL) throw new Error('API_EVENTS_URL is not defined');
  }

  const sender = getSender({
    type: 'web-kb-event-2',
    endpointURL: API_EVENTS_URL as string,
  });

  const batch = new Batch({
    handler: sender,
    withUnload: !isCypressMode,
    interval: isCypressMode ? 0 : undefined,
  });
  setBatcher(batch);

  if (isCypressMode) {
    (window as any)._batch = batch;
  }

  return { batch };
}

export function setAnalyticsIsEnabled(isEnabled: boolean) {
  setConfig({ isDisabled: !isEnabled });
}
